// SidebarView Collapse
const SIDEBARVIEW = 'SIDEBARVIEW';
const LOGINDATA='LOGINDATA';
const PATIENTGETIDCOMMON='PATIENTGETIDCOMMON';
// while choosing reset pswd in profile update when trying to change url as login this will get value based login /dashboard
const RESETPWDDATA='RESETPWDDATA';

// Translation
const TRANSLATE_REQUEST = 'TRANSLATE_REQUEST';
const TRANSLATE_SUCCESS = 'TRANSLATE_SUCCESS';
const TRANSLATE_FAILURE = 'TRANSLATE_FAILURE';

// Authentication Type
const AUTHENTICATION_TYPE_REQUEST='AUTHENTICATION_TYPE_REQUEST';
const AUTHENTICATION_TYPE_SUCCESS='AUTHENTICATION_TYPE_SUCCESS';
const AUTHENTICATION_TYPE_FAILURE='AUTHENTICATION_TYPE_FAILURE';


export {
    SIDEBARVIEW,
    LOGINDATA,
    RESETPWDDATA,
    PATIENTGETIDCOMMON,
    TRANSLATE_REQUEST,
    TRANSLATE_FAILURE,
    TRANSLATE_SUCCESS,
    AUTHENTICATION_TYPE_REQUEST,
    AUTHENTICATION_TYPE_SUCCESS,
    AUTHENTICATION_TYPE_FAILURE,
    
};